/**
 * Created by Jie Gao on 2018-11-09.
 */
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {TimelineLite} from "gsap";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {GGReelSymbolH} from "../../symbols/GGReelSymbolH";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GGReelView} from "../../reel/GGReelView";
import {GGSoundConfig} from "../../GGSoundConfig";
import {GGGameConfig} from "../../GGGameConfig";

export class BombPresentation extends WinPresentationController {
    private _timeline:TimelineLite | null;
    private _bombMultiplier:number;
    private _bombs:boolean[][];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "BombPresentation", skippable : false});
    }

    protected hasWin():boolean {
        // #576
        if (GGGameConfig.instance.FAULTY_WIN_CAP) {
            return false;
        }

        return (<GGParsedGameData>this._gameData)!.xBombs.bomb;
    }

    protected parseFeatureGameData(data:GGParsedGameData):void {
        this._bombs = data.xBombs.bombsPositions;
        this._bombMultiplier = data.xBombs.displayMultiplier;
    }

    protected startWinPresentation():void {
        this._timeline = new TimelineLite({paused : true});
        for(let i:number = 5; i > -1; i--) {
            this._bombs[i].forEach((hasBomb:boolean, j:number) => {
                if(hasBomb) {
                    const bomb:GGReelSymbolH = <GGReelSymbolH>Reels.getSymbol(i, j)!;
                    (<GGReelView>Reels.getReel(i)!.view).addSymbolToWinContainer(bomb, true);
                    this._timeline!.add(bomb.playMultiAnimation(), 0);
                }
            });
        }

        this._timeline.add(() => GGGameModuleConfig.soundPlayer.playSoundEffect(GGSoundConfig.BOMB_ADD_MULTIPLIER),0);
        this._timeline.add(() => this.finish());
        this._timeline.play(0);
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted && this._timeline && this._timeline.isActive()) {
            this._timeline.pause();
            this._timeline.kill();
        }
        GGGameModuleConfig.betWaysOnReel.updateBombMultiplier();
        this._timeline = null;
    }
}